import { Expose, Transform } from 'class-transformer';
import { Model } from './model';

export class WhiteLabelGendersStatistics extends Model {
  @Expose() male: number;
  @Expose() female: number;
  @Expose()
  @Transform(({ obj }) => obj?.male + obj?.female || 0)
  total: number;
}
